export class TemplateCategory{
    id : number = 0;
    name : string = "" //カテゴリー名
    count = 0 //テンプレート数
    isLeaf : boolean = false //子供を持っていればfalse、持っていなければtrue
    children : this[] = [] //子供を持っていればいれてください
    isSelected : boolean = false //選択されたものだけtrue
    isExpanded : boolean = false //選択状態にあるカテゴリーの親とその親はtrue、それ以外false
    firstNode : boolean = false //第一階層目(productのカテゴリー)であればtrue、それ以外false
    isVisible : boolean = false //とりあえず常にtrue
    isDraggable : boolean = false //常にfalse
    isSelectable : boolean = false //常にtrue
    data : any[] = [] //空の配列をください
    path : string = ""
    hierarchy : number = 1 //何階層目にあるか(1,2,3の3種類。)

    public constructor(name: string = "") {
        this.name = name;
    }
}
